<template>
  <b-container class="p-5">
    <div class="d-flex justify-content-center mx-auto pb-4" style="width: 100%; flex-wrap: wrap;">
      <!-- <div style="margin-right: 5em;" v-if="isMobileDevice == false"></div>
        <span style="font-size: 32px; font-family: Quicksand-Bold;"> Invoice Analytics </span> 
        <invoice-filter style="width: 100px; margin-left: 1em;" @filter="selectFilter" />  -->
        <b-form-checkbox
          size="lg"
          id="ToggleAED"
          v-if="currency != 'AED'" 
          v-model="currencyAED"
          inline
          > 
          View in AED 
        </b-form-checkbox>
        <hr class="flex-break"/>
        <div class="my-3 business-input d-flex justify-content-center">
          <date-range-picker
            :startDate="dateRange[0]"
            :endDate="dateRange[1]"
            type="date"
            :customRanges="ranges"
            @date-select="filterPayablesAnalyticsByDate"
          ></date-range-picker>
            <multiselect-dropdown   class=""
            style="width: 20rem !important; margin-left: 2rem;"
            v-if="merchantsList.length"
            :options="merchantsList" 
            allLabel="All Merchants"
            :multiple="true"
            :sideSingle="true"
            :value="queryMerchant"
            @item-select="filterMerchants"/>
          <hr cass="flex-break"/>
        </div>
      </div>
    </div>
    <b-row class="py-3" v-for="(rows, ind) in fields" :key="ind">
      <b-col :cols="isMobileDevice == true ? '12' : '3'"><span style="font-size: 18px; font-family: Quicksand-Bold;">{{
        analyticsFields[ind] }}</span></b-col>

      <b-col v-for="(field, index) in rows" :key="index" :cols="isMobileDevice == true ? '6' : '2'">
        <custom-cards :field="field" :index="ind" :isMobileDevice="isMobileDevice"
          :formatTableCurrency="formatTableCurrency(field.numeric, currency)"
          :formatThousands="formatThousands(field.numeric)"
          :prorateddata="getProrateddata(field.numeric, field.mapping)" :columns="isMobileDevice == true ? '6' : '3'"
          :loading=loading></custom-cards>
      </b-col>
    </b-row>
    <!-- <b-row class="justify-content-md-center">
      <apexchart
        type="polarArea"
        :series="chartValues"
        width="500"
        :options="options"
      />
    </b-row> -->
  </b-container>
</template>

<script>
import AnalyticsService from "@/services/analytics.service";
import InvoiceFilter from "./components/InvoiceFilter.vue"
import DateRangePicker from "@/views/pages/companies/components/DateRangePicker.vue";
import { DateRanges} from '@/dateRanges.js'
import { DateTime } from "luxon";
import MultiselectDropdown from "../../../components/multiselect.dropdown.vue";
import customCards from "./components/customCards.vue";
import { GET_ALL_MERCHANTS } from "@/store/monthlydata";
import { mapGetters, mapState } from 'vuex';
import { validateAdminQueryParameter } from "@/store/invoice/helpers";
import { QUERY_PARAMETERS_ACTIONS } from "@/store/queryparams";
export default {
  name: "nice",
  components: {
    InvoiceFilter,
    DateRangePicker,
    MultiselectDropdown,
    customCards,
  },
  data() {
    return {
      filter: "invoices",
      data: null,
      currency: 'AED',
      currencyAED: false,
      total: 0,
      loading: true,
      merchant: null,
      queryMerchant:null,
      isMobileDevice: false,
      dateRange: [],
      diffDays: 0,
      ranges: {
        'This Month': DateRanges['This Month'],
        'Last Month': DateRanges['Last Month'],
        'Last 30 Days': DateRanges['Last 30 Days'],
        'This Quarter': DateRanges['This Quarter'],
        'Last Quarter': DateRanges['Last Quarter'],
        'This Year': DateRanges['This Year'],
        'Last Year': DateRanges['Last Year'],
        'All Time': DateRanges['All Time']
      },
      fields: [
        [
          {
            title: "Merchants",
            numeric: 0,
            mapping: ["current","merchants_count"],
            isCurrency: false,
          },
          {
            title: "Payers",
            numeric: 0,
            mapping: ["current","payers_count"],
            isCurrency: false,
          },
          {
            title: "Buyers",
            numeric: 0,
            mapping: ["current","buyers_count"],
            isCurrency: false,
          },
          {
            title: "Users",
            numeric: 0,
            mapping: ["current", "users_count"],
            isCurrency: false,
          }
        ],
        [
          {
            title: "Invoices",
            numeric: 0,
            mapping: ["current", "invoices_analytics", "invoices_count"],
            isCurrency: false,
          },
          {
            title: "Invoice Volume",
            numeric: 0,
            mapping: ["current", "invoices_analytics", this.currencyAED ? "invoices_sum_AED" : "invoices_sum"],
            isCurrency: true,
          }],
        [
          {
            title: "Payments",
            numeric: 0,
            mapping: ["current", "payments_analytics", "payments_count"],
            isCurrency: false,
          },
          {
            title: "Payment Volume",
            numeric: 0,
            mapping: ["current", "payments_analytics", this.currencyAED ? "payments_sum_AED" : "payments_sum"],
            isCurrency: true,
          },
          {
            title: "% Paid",
            numeric: 0,
            mapping: ["current", "payments_analytics", "percent_paid"],
            isCurrency: false,
            ispercent: true,
          },
          {
            title: "% Paid Volume",
            numeric: 0,
            mapping: ["current", "payments_analytics", "percent_paid_volume"],
            isCurrency: false,
            ispercent: true,
          },
        ],
        [
          {
            title: "Payments (Kema)",
            numeric: 0,
            mapping: ["current", "payments_analytics", "payments_count_kema"],
            isCurrency: false,
          },
          {
            title: "Payment Volume (Kema)",
            numeric: 0,
            mapping: ["current", "payments_analytics", this.currencyAED ? "payments_sum_kema_AED" : "payments_sum_kema"],
            isCurrency: true,
          },
          {
            title: "% Kema Paid",
            numeric: 0,
            mapping: ["current", "payments_analytics", "percent_kema_paid"],
            isCurrency: false,
            ispercent: true,
          },
          {
            title: "% Kema Paid Volume",
            numeric: 0,
            mapping: ["current", "payments_analytics", "percent_kema_paid_volume"],
            isCurrency: false,
            ispercent: true,
          },
        ], [
          {
            title: "Emails Sent",
            numeric: 0,
            mapping: ["current", "invoices_analytics", "emails_sent"],
            isCurrency: false,
          },
          {
            title: "Emails Viewed",
            numeric: 0,
            mapping: ["current", "invoices_analytics", "emails_viewed"],
            isCurrency: false,
          },], [
          {
            title: "Buyers",
            numeric: 0,
            mapping: ["current", "invoices_analytics", "buyers_count"],
            isCurrency: false,
          },

          {
            title: "Invoices Opened",
            numeric: 0,
            mapping: ["current", "invoices_analytics", "invoice_opened"],
            isCurrency: false,
          },
        ]
      ],
      analyticsFields: [
        'Business', 'Invoices', '', '', 'Emails', ''
      ],
    };
  },
  created() {
    this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.RESET_QUERY_PARAMS);
    let regexp = /android|iphone|kindle|ipad/i; 
    this.isMobileDevice = regexp.test(navigator.userAgent); 
    this.$store.dispatch(GET_ALL_MERCHANTS, { is_merchant: "True" })
      .catch(({ message }) => {
        this.error = "There was an error loading companies.";
      });
    if (this.$route.query.due_start && this.$route.query.due_end) {
      this.dateRange = [DateTime.fromJSDate(new Date(this.$route.query.due_start)), DateTime.fromJSDate(new Date(this.$route.query.due_end))]
    }
    else {
      this.dateRange = DateRanges['This Month'];
    }
    if( this.$route.query.id){
      this.queryMerchant = this.$route.query.id.split(",");
      this.merchant = this.$route.query.id.split(",");  
    }
  },
  computed:{
    ...mapState({
      merchantsList: (state) => state.monthlydata.merchants,
    })
  },
  mounted(){
    // if(this.merchant.length == 1 && this.merchantsList.length){
    //     this.currency = this.merchantsList.find((obj)=>obj.id == this.merchant[0])?.base_currency;
    //   }
  },
  methods: {
    filterMerchants(eventip){
      if(eventip == null){
        // this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.REMOVE_PARAMS_FROM_URL, this.$route.path);
        this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.RESET_QUERY_PARAMS);
        this.merchant =null;
        this.currency ='AED'
        this.getAnalytics();
      }
      else{
        if(eventip.length >0){
          let currencyArr = [...new Set(eventip.map((item)=> item.base_currency))];
          this.currency = currencyArr.length >1 ? 'AED': currencyArr[0]
          this.merchant = eventip.map((item)=> item.id);
          this.getAnalytics()
        }
        if (eventip.length == 0) {
          // this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.REMOVE_PARAMS_FROM_URL, this.$route.path);
          this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.RESET_QUERY_PARAMS);
          this.merchant = null;
          this.currency = 'AED'
          this.getAnalytics();
        }
      }
    },
    getDifferencePrevious(selection, refdate) {
      switch (selection) {
        case 'This Month':
          return refdate.minus({ months: 1 }).toUTC().toString()
        case 'This Quarter':
          return refdate.minus({ months: 3 }).toUTC().toString()
        case 'This Year':
          return refdate.minus({ year: 1 }).toUTC().toString()
        default:
          return refdate.toUTC().toString()
      }
    },
    getAnalytics() {
      this.loading = true;
      this.currencyAED = false;
      this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.RESET_QUERY_PARAMS);
      let params = {}
      if (this.dateRange !== void 0) {
        let diffTime = Math.abs(new Date(this.dateRange[1] - new Date(this.dateRange[0])));
        this.diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
        params = {
          "due_start": this.dateRange[0].toUTC().toString(),
          "due_end": this.dateRange[1].toUTC().toString(),
          "pre_start": this.dateRange[2].startsWith('This') ? this.getDifferencePrevious(this.dateRange[2], this.dateRange[0]) : this.dateRange[0].minus({ days: this.diffDays }).toUTC().toString(),
          "pre_end": this.dateRange[2].startsWith('This') ? this.getDifferencePrevious(this.dateRange[2], this.dateRange[1]) : this.dateRange[0].toUTC().toString()
        }
        let currentPath = this.$route.path;
        const payload = validateAdminQueryParameter({'due_start':this.dateRange[0].toUTC().toString(),"due_end": this.dateRange[1].toUTC().toString()});
        this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.ADD_FILTER_QUERY_PARAMETER, {payload, currentPath})
      }
      if (this.filter !== null) {
        params = {
          ...params,
          "status": this.filter
        }
      }

      if (this.merchant) {
        params = {
          ...params,
          "id": this.merchant.join(',')
        };
        let currentPath = this.$route.path;
        const payload = validateAdminQueryParameter({'id':this.merchant.join(',')});
        this.$store.dispatch(QUERY_PARAMETERS_ACTIONS.ADD_FILTER_QUERY_PARAMETER, {payload, currentPath})
      }

      if (!this.merchant) {
        AnalyticsService.query(params)
          .then(({ data }) => {
            this.data = data;
            if (data.current['noexchange'].length > 0) {
              this.$showAlert('Exchange rates are not available for ' + data.current['noexchange'].toString(), 'danger');
            }
            this.applyFilter();
            this.loading = false;
          })
          .catch((error) => {
            console.log(error);
            this.$showAlert(error.message, 'danger');
          })
          .finally(() => {
            this.loading = false;
          });
      }
      else {
        AnalyticsService.get('merchants', params)
          .then(({ data }) => {
            this.data = data;
            this.data.current["invoices_analytics"] = data.current["invoices_analytics"];
            this.data.current["payments_analytics"] = data.current["payments_analytics"];
            if (data.current['noexchange'].length > 0) {
              this.$showAlert("Exchange rates are not available for " + data.current['noexchange'].toString(), 'danger');
            }
            this.applyFilter();
            this.loading = false;
          })
          .catch((error) => {
            console.log(error);
            this.$showAlert(error.message, 'danger');
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    applyFilter() {
      this.fields.map((row) => {
        row.map((field) => {
          field.numeric = 0
        })
      });
      this.fields.map((row) => {
        row.map((field) => {
          field.numeric = field.mapping.reduce((object, property) => object[property] || 0, this.data)
        })
      });
    },
    filterPayablesAnalyticsByDate(date_range) {
      let { startDate, endDate, label } = date_range;
      if (typeof startDate === 'string') {
        startDate = DateTime.fromISO(startDate);
      }
      if (typeof endDate === 'string') {
        endDate = DateTime.fromISO(endDate);
      }

      this.dateRange = [startDate, endDate, label];
      this.getAnalytics(this.merchant)
    },
    formatThousands(amount) {
      const formattedAmount = new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(amount);

      let splitAmount = formattedAmount.split(".");
      return splitAmount[1] > 0 ? formattedAmount : splitAmount[0];
    },
    formatTableCurrency(amount) {
      const formattedAmount = new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        notation: 'compact'
      }).format(amount);
      let splitAmount = formattedAmount.split(".");
      return `
        <strong class="numeric"><span style="vertical-align: super; font-size: 12px; margin-right:5px; font-weight: 500; ">${this.currencyAED ? 'AED' : this.currency}</span>${splitAmount[1].length > 2 ? formattedAmount : splitAmount[0]}<span style=" font-size: 12px; margin-right:5px; font-weight: 500; ">${splitAmount[1].length <= 2 ? '.' + splitAmount[1] : ''} </span></strong>
      `;
    },
    selectFilter(filter) {
      switch (filter.toLowerCase()) {
        case "all":
          this.filter = null;
          break;
        case "paid":
          this.filter = "paid";
          break;
        case "settled":
          this.filter = "settled";
          break;
        case "overdue":
          this.filter = "overdue";
          break;
        case "due":
          this.filter = "due";
          break;
        default:
          this.filter = null;
      };
      this.getAnalytics(this.merchant);
    },
    getProrateddata(value, field) {
      if (this.data !== null && (field.includes('invoices_analytics') || field.includes('payments_analytics'))) {
        let preveousValue = this.data['previous'][field[1]][field[2]]
        let prevProrate = (preveousValue / this.diffDays)
        let currProrate = (value / this.diffDays)
        let prorateValue = 0
        let proratedata = 0
        let diffTime = Math.abs(new Date(this.dateRange[0]) - new Date());
        let futdiffTime = Math.abs(new Date(this.dateRange[1]) - new Date());
        let prediffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
        let futdiffdays = Math.floor(futdiffTime / (1000 * 60 * 60 * 24)) + 1;
        let currentDT = new Date().getTime()
        var htmlstr = ``
        if (currentDT > new Date(this.dateRange[0]).getTime() && currentDT < new Date(this.dateRange[1]).getTime()) {
          proratedata = Math.floor(((value / prediffDays) * futdiffdays) + value)
          prorateValue = Math.floor(((proratedata - preveousValue) / preveousValue) * 100)
          if (preveousValue == 0) {
            prorateValue = 0
          }
          if (prorateValue > 0) {
            htmlstr = `<span style=" color: #54b854;" class="value_hover" 
            v-b-tooltip.hover data-title="Expected to reach ${this.formatThousands(proratedata)}\n Up from ${this.formatThousands(preveousValue)}  in the previous period" > <i style="color:#54b854; font-size:12px;" class="material-icons">timeline</i> ${this.formatThousands(prorateValue)}% <i style="color:#54b854; font-size:16px;" class="material-icons">arrow_upward</i></span>`
          }
          else if (prorateValue < 0) {
            htmlstr = `<span style=" color: #ee7474;" class="value_hover" data-title="Expected to reach ${this.formatThousands(proratedata)}\n Down from ${this.formatThousands(preveousValue)}  in the previous period" > <i style="color:#ee7474; font-size:12px;" class="material-icons">timeline</i> ${this.formatThousands(prorateValue)}% <i style="color:#ee7474; font-size:16px;" class="material-icons">arrow_downward</i></span>`
          }
          else {
            htmlstr = `<span style=" color: #a4a4a4;"> - </span>`
          }
        }
        else {
          prorateValue = ((value - preveousValue) / preveousValue) * 100
          if (preveousValue == 0) {
            prorateValue = 0
          }
          if (Math.floor(prorateValue) > 0) {
            prorateValue = Math.floor(prorateValue)
            htmlstr = `<span style=" color: #54b854;" class="value_hover" data-title="Up from ${this.formatThousands(preveousValue)} in the previous period" > ${this.formatThousands(prorateValue)}% <i style="color:#54b854; font-size:16px;" class="material-icons">arrow_upward</i></span>`
          }
          else if (Math.floor(prorateValue) < 0) {
            prorateValue = Math.floor(prorateValue)
            htmlstr = `<span style=" color: #ee7474;" class="value_hover" data-title="Down from ${this.formatThousands(preveousValue)} in the previous period" > ${this.formatThousands(prorateValue)}% <i style="color:#ee7474; font-size:16px;" class="material-icons">arrow_downward</i> </span>`
          }
          else {
            prorateValue = Math.floor(prorateValue)
            htmlstr = `<span style=" color: #a4a4a4;"> - </span>  `
          }
        }
        return htmlstr
      }
    }
  },
  watch: {
    currencyAED(newval) {
      if (newval) {
        this.fields[1][1].mapping = ["current", "invoices_analytics", "invoices_sum_AED"]
        this.fields[3][1].mapping = ["current", "payments_analytics", "payments_sum_kema_AED"]
        this.fields[2][1].mapping = ["current", "payments_analytics", "payments_sum_AED"]
      }
      else {
        this.fields[1][1].mapping = ["current", "invoices_analytics", "invoices_sum"]
        this.fields[3][1].mapping = ["current", "payments_analytics", "payments_sum_kema"]
        this.fields[2][1].mapping = ["current", "payments_analytics", "payments_sum"]
      }
      this.applyFilter();
    },
    merchantsList(val){
      if(val && this.merchant?.length == 1 && val?.length){
        this.currency = val.find((obj)=>obj.id == this.merchant[0])?.base_currency;
      }
    }
  }

};
</script>

<style lang="scss">
@import './index.scss';
</style>